<template>
  <div>
    <el-date-picker
      style="width:100%"
      start-placeholder="απο"
      end-placeholder="εως"
      v-model="content"
      value-format="timestamp"
      :format="displayFormat"
      :type="type"
      :picker-options="pickerOptions"
    ></el-date-picker>
  </div>
</template>

<script>
// pattern="^([0]?[1-9]|[1|2][0-9]|[3][0|1])/([0]?[1-9]|[1][0-2])/(19|20)\d\d$"
import * as dateHelper from "date-fns";
export default {
  name: "r-dater",
  data() {
    return {
      content: []
    };
  },
  props: {
    type: { type: String, default: "daterange" },
    value: { default: null },
    rangeBySeprator: { type: String, default: null },
    displayFormat: {
      default: "dd/MM/yyyy"
    },

    exportFormat: {
      default: "DD/MM/YYYY"
    },
    importFormat: {
      default: "DD/MM/YYYY"
    }
  },
  computed: {
    pickerOptions() {
      if (this.type != "daterange") return;
      var vm = this;
      return {
        shortcuts: [
          {
            text: "Σήμερα",
            onClick(picker) {
              const date = new Date();
              vm.content = [date.getTime(), date.getTime()];
            }
          },
          {
            text: "Μήνας",
            onClick(picker) {
              const date = new Date();
              vm.content = [
                date.getTime() - 3600 * 1000 * 24 * 30,
                date.getTime()
              ];
              // date.setTime();
              picker.$emit("pick", vm.content);
            }
          },
          {
            text: "Χρόνος",
            onClick(picker) {
              const date = new Date();
              vm.content = [
                date.getTime() - 3600 * 1000 * 24 * 365,
                date.getTime()
              ];
              // date.setTime();
              picker.$emit("pick", vm.content);
            }
          }
        ]
      };
    }
  },
  watch: {
    value(value, ov) {
      if (value == ov) return;
      this.setContent();
    },
    content(value, oldVal) {
      if (this.type != "daterange") {
        if (value == oldVal) return;
        // _log_("hel.ww.v.", value);
        // if (_.isNumber(value)) value = value * 1000;
        var e = null;
        if (value) {
          if (this.exportFormat == "unixtime") {
            e = new Date(value);
            e = e.getTime() / 1000;
          } else e = dateHelper.format(new Date(value), this.exportFormat);
        }
        // _log_("hel.ww..", e);
        this.$emit("input", e);
        this.$emit("change", e);

        return;
      }

      if (!value) {
        if (oldVal) this.$emit("input", []);
        return;
      }
      if (!value.length) {
        if (oldVal) this.$emit("input", []);
        return;
      }

      //      _log_("hel.ww..", value[0],dateHelper.format((new Date(value[0])),this.exportFormat));
      // //   _log_("hel.ww..", value);

      e = [
        dateHelper.format(new Date(value[0]), this.exportFormat),
        dateHelper.format(new Date(value[1]), this.exportFormat)
      ];
      if (this.rangeBySeprator) e = e.join(this.rangeBySeprator);
      this.$emit("input", e);
      this.$emit("change", e);
    }
  },
  created() {
    this.setContent();
    // const date = new Date();
    // this.content = [date.getTime(), date.getTime()];
  },
  methods: {
    setContent() {
      const c = this.value > 1000 ? this.value : null;
      if (c && this.importFormat == "unixtime") this.content = c * 1000;
      else this.content = c;
    }
  }
};
</script>
